import script from "./TopUpPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopUpPage.vue?vue&type=script&setup=true&lang=ts"

import "./TopUpPage.vue?vue&type=style&index=0&id=d69a2af0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d69a2af0"]])

export default __exports__